import { render, staticRenderFns } from "./FormV2.vue?vue&type=template&id=23a15fda&scoped=true"
import script from "./FormV2.vue?vue&type=script&lang=js"
export * from "./FormV2.vue?vue&type=script&lang=js"
import style0 from "./FormV2.vue?vue&type=style&index=0&id=23a15fda&prod&scoped=true&lang=css"
import style1 from "./FormV2.vue?vue&type=style&index=1&id=23a15fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a15fda",
  null
  
)

export default component.exports